import { useParams } from 'react-router-dom';

export function useProjectId(): ID {
    const { projectId } = useParams<{ projectId?: string }>();

    return parseInt(projectId ?? '');
}
